const priority_options = [
  { label: "Normalny", value: "standard" },
  { label: "Pilne", value: "urgent" },
];

export default priority_options;
